// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1ac5cdea","239":"a5c05d13","488":"e4af5582","667":"c559afd2"}[chunkId] + ".chunk.js";
};